import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "draivn-help-center-top-toolbar drv-pl-6 drv-pr-4 drv-py-3" }
const _hoisted_2 = { class: "block" }

import { EMessagesKeys } from "../../types";
import BreadcrumbsBlock from "./BreadcrumbsBlock.vue";
import {
  useShowSupportDialogFeature,
  useShowDemoDialogFeature,
} from "../../composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopToolbar',
  setup(__props) {

const { showSupportDialog } = useShowSupportDialogFeature();
const { showDemoDialog } = useShowDemoDialogFeature();

return (_ctx: any,_cache: any) => {
  const _component_d_icon = _resolveComponent("d-icon")!
  const _component_d_btn = _resolveComponent("d-btn")!
  const _component_d_separator = _resolveComponent("d-separator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbsBlock),
      _createVNode(_component_d_btn, {
        variant: "secondary",
        onClick: _unref(showSupportDialog)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_d_icon, {
            name: "messages",
            class: "drv-mr-2"
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(_unref(EMessagesKeys).CONTACT_SUPPORT_TITLE)), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_d_separator)
  ], 64))
}
}

})